import { networkActionsCreator } from '../../../../../admincore'

const actions = {
  ...networkActionsCreator('account/details'),
}

export default actions

export function load(id) {
  return {
    type: actions.LOAD,
    payload: {
      id,
    },
  }
}

export function reset() {
  return {
    type: actions.RESET,
  }
}
